import Controller, { inject as controller } from '@ember/controller';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { task } from 'ember-concurrency';
import { waitFor } from '@ember/test-waiters';

export default class WorkInstructionsIndexController extends Controller {
  @service workInstructionRepo;
  @service router;
  @service store;
  @service currentUser;
  @service notifier;
  @service intl;

  @tracked selectedFolder;

  @controller('workInstructions') WorkInstructionsController;

  get canCreate() {
    return this.workInstructionRepo.userCanCreate(this.selectedFolder);
  }

  get canCreateFolder() {
    return this.workInstructionRepo.userHasRootFolderEditor();
  }

  @action
  onDelete(currentWorkInstructionIsDeleted) {
    if (!currentWorkInstructionIsDeleted) {
      return;
    }

    this.router.transitionTo('workInstructions');
  }

  export = task(waitFor(async (downloads, fileType) => {
    const queue = Array.isArray(downloads) ? downloads : [downloads];
    await this.workInstructionRepo.downloadInstructions.perform(queue, fileType);
  }));

  @action
  loadWorkInstruction(workInstruction) {
    this.router.transitionTo('workInstructions.workInstruction', workInstruction.id);
  }
}
